export const setUpdate = (data) => {
    return {
      type: 'SET_UPDATE',
      payload: data
    };
  };